<template>
    <div class="contact-form">
        <div class="contact-form__wrapper" v-if="loading">
            <div class="contact-form__loader" ></div>
        </div>
        <div class="contact-form__success" ref="success" v-show="success">
            Thank you for your enquiry, a member of our team will be in touch as soon as possible.
        </div>

        <div class="contact-form__errors" ref="error" v-show="errors">
            We have detected some errors with your submission
            <ul>
                <li v-for="error in errors">
                    <span v-for="message in error">{{message}}</span>
                </li>
            </ul>
        </div>
        <div class="contact-form-section">
            <div class="row">
                <div class="col-md-4">
                    <span class="contact-form-section__label">
                        I'm Interested In
                    </span>
                </div>
                <div class="col-md-8">
                    <div class="contact-form-types-wrapper">
                        <div class="contact-form-types">
                            <button class="contact-form-types__type"
                                    v-for="type in types"
                                    :class="{'contact-form-types__type--active':type.active}"
                                    v-on:click="setFormType(type)">
                                {{type.name}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <wedding-form v-if="activeType.name == 'weddings'" :include-location="true" :form="types.weddings.model" @submit="submit"></wedding-form>

        <event-form v-if="activeType.name == 'Events'" :include-location="true" :form="types.events.model" @submit="submit"></event-form>

        <general-form v-if="activeType.name == 'General'" :form="types.general.model" @submit="submit"></general-form>


    </div>
</template>
<script>
    import qs from 'qs'
    import WeddingForm from './forms/weddingForm.vue'
    import EventForm from './forms/EventForm.vue'
    import FodderForm from './forms/FodderForm.vue'
    import GeneralForm from './forms/GeneralForm.vue'
    import BushcraftForm from './forms/BushcraftForm.vue'
    // import * as moment from 'moment';

    export default {
        props: ['initialType', 'forms'],
        components: {
            WeddingForm,
            EventForm,
            FodderForm,
            GeneralForm,
            BushcraftForm
        },
        data() {
            return {
                types: {
                   weddings: {name: 'weddings', active: true, model: {subject: 'Wedding Form Submission',toEmail: 'tipis@magnakata.com',message:{}}},
                   events: {name: 'Events', active: false, model: {subject: 'Event Form Submission', toEmail: 'tipis@magnakata.com', listID:'22d473c711',message:{}}},
                   // fodder: {name: 'Fodder', active: false, model: {subject: 'Fodder Form Submission',toEmail:'laura@fodderni.com', message:{}}},
                    general: {name: 'General', active: false, model: {subject: 'General Form Submission', toEmail:'tipis@magnakata.com',message:{}}},
                },
                success: false,
                loading: false,
                errors: null
            }
        },
        mounted() {
          if (this.initialType) this.setFormType(this.types[this.initialType]);
        },
        methods: {
            setFormType(type) {
                for (let key in this.types) {
                    this.types[key].active = false;
                }
                type.active = true;
            },

            submit(type, data) {
                this.reset();

                type = this.types[type];
                data[this.csrfName] = this.csrfToken;
                data['action'] = 'contact-form/send';

                // convert dates to human readable
                // for (let key in type.model.message) {
                //     if (Date.parse(type.model.message[key])) {
                //         data.message[key] = this.dateFormatter(data.message[key]);
                //     }
                // }

                this.loading = true;
                axios.post('/', qs.stringify(data))
                    .then(response => {
                        if (response.data.errors) {
                            this.errors = response.data.errors;
                            this.$nextTick(() => {
                                $('html, body').animate({scrollTop: $(this.$refs.error).offset().top - 100})
                            });
                        } else {
                            this.success = true;
                            this.$refs.success.scrollIntoView();
                            this.$nextTick(() => {
                                $('html, body').animate({scrollTop: $(this.$refs.success).offset().top - 100})
                            });
                        }
                        this.loading = false;
                    })
            },
            /**
             * Reset Form
             */
            reset() {
                this.errors = false;
                this.success = false;
            },
            /**
             * Reset Form Data
             */
            resetForm() {
              for (let type in this.types) {
                  this.types[type].model= {message:{}};
              }
            },
            /**
             * Format dates
             * @param date
             * @returns {string}
             */
            // dateFormatter(date) {
            //     return moment(date).format('MMMM Do YYYY');
            // }
        },
        computed: {
            activeType() {
                for (let key in this.types) {
                    if (this.types[key].active) return this.types[key];
                }
                return null;
            },
            csrfName () {
                return window.csrfTokenName
            },
            csrfToken () {
                return window.csrfTokenValue
            }
        }
    }
</script>